import { render, staticRenderFns } from "./DatosUsuario.vue?vue&type=template&id=581e2acb&scoped=true"
import script from "./DatosUsuario.vue?vue&type=script&lang=js"
export * from "./DatosUsuario.vue?vue&type=script&lang=js"
import style0 from "./DatosUsuario.vue?vue&type=style&index=0&id=581e2acb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "581e2acb",
  null
  
)

export default component.exports